/**
 * Parse authData providers are derived from the Auth0 `sub`, never from a
 * generic "auth0" provider. The Parse Server adapter stores one binding per
 * provider (`authData.<provider>.id`), so the prefix must match the connection
 * the subject came from.
 */
export const PARSE_AUTH0_PROVIDER_PREFIXES = Object.freeze([
  ['auth0', 'auth0|'],
  ['auth0Google', 'google-oauth2|'],
  ['auth0Apple', 'apple|'],
]);

/**
 * @param {unknown} subject Auth0 `sub` claim.
 * @returns {'auth0'|'auth0Google'|'auth0Apple'}
 * @throws {Error} when the subject is missing or its prefix is unsupported.
 */
export const auth0ProviderForSubject = (subject) => {
  if (typeof subject !== 'string' || !subject.trim()) {
    throw new Error('Auth0 identity is missing');
  }

  const match = PARSE_AUTH0_PROVIDER_PREFIXES.find(
    ([, prefix]) => subject.startsWith(prefix) && subject.length > prefix.length
  );

  if (!match) {
    throw new Error('Unsupported Auth0 identity');
  }

  return match[0];
};

export const isSupportedAuth0Subject = (subject) => {
  try {
    auth0ProviderForSubject(subject);
    return true;
  } catch {
    return false;
  }
};
